






































































import { Component, Vue } from 'vue-property-decorator';
import Jumbotron from '@/components/Jumbotron.vue';

const addBG = (img: any) => `url(${img}) no-repeat center center`;

@Component({
  components: {
    Jumbotron,
  },
})
export default class Home extends Vue {
  private swiperOption = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
  };
  private aboutus = require('@/data.json').home.aboutus;
  private textSides = [...Array(4).keys()].map(i => (
    addBG(require(`@/images/home/text${i + 1}.jpg`))
  ));
}
